// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5549 ? "ef01c9fb" : chunkId) + "." + {"1062":"2311129d903fc602","5549":"572cac806ed7043c","7127":"bdc53a323ab9e4b2","7850":"88a40941de968d4a"}[chunkId] + ".js";
};